export const termsTranslation = {
  message: 'By creating an account, I agree to the <link1 /> and <link2 />.',
  user_terms: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  upload: 'Drop files here or click',
  browse: 'browse',
  machine: 'your device'
};
